const Maps = ({ urlMap, title, styleMap }) => {
  return <iframe src={urlMap} title={title} className={styleMap} />;
};

export default Maps;
